export default __webpack_public_path__ + "static/media/Peter Michael Mastrofrancesco - Sponsorship Associate.750472bb.jpg";